import type { JSX } from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Box from "@mui/material/Box";
import {
  AttributeGroupHeadline,
  AttributeGroupProps,
  useAttributeGroupExpansionState,
  useConfigurationGroupScrolling,
} from "@plansoft-configuration-renderer/components";

export function CustomAttributeGroupAccordion(
  props: AttributeGroupProps,
): JSX.Element {
  const { defaultIsExpanded, title } = props;

  const { isExpanded, setIsExpanded } = useAttributeGroupExpansionState({
    defaultIsOpen: defaultIsExpanded,
    groupId: title,
  });

  const groupRef = useConfigurationGroupScrolling({ groupId: title });

  return (
    <Box
      ref={groupRef}
      sx={{
        my: "1em",
        borderRadius: 1,
        boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
      }}
      className="attribute-group-accordion"
    >
      <Accordion
        expanded={isExpanded}
        onChange={() => setIsExpanded(!isExpanded)}
        slotProps={{
          transition: { unmountOnExit: true },
        }}
        sx={{
          px: 1,
          pb: 1,
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          component="div"
          sx={{
            // global MuiSvgIcon fontSize is too large next to the group title
            "& .MuiAccordionSummary-content .MuiSvgIcon-root": {
              fontSize: "1.25rem",
            },
          }}
        >
          <AttributeGroupHeadline {...props} />
        </AccordionSummary>
        <AccordionDetails>{props.children}</AccordionDetails>
      </Accordion>
    </Box>
  );
}
